import { useGameStore } from "../state/store";
import { Dashboard } from "../components/dashboard/Dashboard";
import { ContractBoard } from "../components/contracts/ContractBoard";
import { ContractDetails } from "../components/contracts/ContractDetails";
import { Workspace } from "../components/workspace/Workspace";
import { LogAnalysis } from "../components/logAnalysis/LogAnalysis";
import { NetworkMap } from "../components/networkMap/NetworkMap";
import { PhishingInbox } from "../components/phishing/PhishingInbox";
import { ReportBuilder } from "../components/reportBuilder/ReportBuilder";
import { ResultScreen } from "../components/result/ResultScreen";
import { SkillsScreen } from "../components/skills/SkillsScreen";
import { SkillDetails } from "../components/skills/SkillDetails";
import { ToolsScreen } from "../components/tools/ToolsScreen";
import { ToolDetails } from "../components/tools/ToolDetails";
import { SettingsScreen } from "../components/settings/SettingsScreen";
import { PrivacyScreen } from "../components/privacy/PrivacyScreen";
import { MainMenuScreen } from "../components/screens/MainMenuScreen";

export function Router(): JSX.Element {
  const screen = useGameStore((state) => state.currentScreen);

  switch (screen) {
    case "main_menu":
      return <MainMenuScreen />;
    case "dashboard":
      return <Dashboard />;
    case "contracts":
      return <ContractBoard />;
    case "contract_details":
      return <ContractDetails />;
    case "workspace":
      return <Workspace />;
    case "log_analysis":
      return <LogAnalysis />;
    case "network_map":
      return <NetworkMap />;
    case "phishing":
      return <PhishingInbox />;
    case "report_builder":
      return <ReportBuilder />;
    case "results":
      return <ResultScreen />;
    case "skills":
      return <SkillsScreen />;
    case "skill_details":
      return <SkillDetails />;
    case "tools":
      return <ToolsScreen />;
    case "tool_details":
      return <ToolDetails />;
    case "settings":
      return <SettingsScreen />;
    case "privacy":
      return <PrivacyScreen />;
    default: {
      const exhaustive: never = screen;
      return exhaustive;
    }
  }
}
